<template>
  <ContentPage back>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">W9 Request</div>
    </template>

    <Section>
      <v-form ref="form" @submit.prevent="submitClick">
        <v-text-field 
          outlined dense validate-on-blur
          v-model="name" label="Business Name (as shown on your tax return)"
          :rules="[required]"
        />
        <v-text-field 
          outlined dense validate-on-blur
          v-model="business_name" label="DBA (if different than above)"
        />
        <v-text-field
          outlined dense validate-on-blur
          v-model="street" label="Street"
          :rules="[required]"
        />
        <v-text-field
          outlined dense validate-on-blur
          v-model="city" label="City"
          :rules="[required]"
        />
        <div class="d-flex">
          <StateSelect
            outlined dense validate-on-blur
            v-model="state" label="State"
            :rules="[required]"
          />

          <v-text-field
            outlined dense validate-on-blur class="ml-2"
            v-model="zipcode" label="Zip Code"
            v-mask="'#####'"
            :rules="[required]"
          />
        </div>

        <div class="d-flex justify-center">
          <v-btn class="ml-3" color="primary" type="submit">Next</v-btn>
        </div>
      </v-form>
    </Section>
  </ContentPage>
</template>

<script>
import { ContentPage, Section } from '@/components/pages'
import { StateSelect } from '@/components/inputs'

import { required } from '@/lib/validations'
import { mapActions, mapGetters } from 'vuex'

export default {
  name :'W9FormPage',

  components: { ContentPage, Section, StateSelect },

  data: () => ({
    name: '',
    business_name: '',
    street: '',
    city: '',
    state: '',
    zipcode: '',


    options: {
      penColor: 'blue',
    },

    // validations
    required,
  }),

  computed: {
    ...mapGetters('accounts', ['w9Progress']),
  },

  methods: {
    ...mapActions('accounts', ['saveW9Progress']),

    resetSignature() {
      this.$refs.signaturePad.clearSignature()
    },

    async submitClick() {
      if (this.$refs.form.validate()) {
        const { name, business_name, street, city, state, zipcode } = this
        
        const payload = { name, business_name, street, city, state, zipcode }

        const result = await this.saveW9Progress(payload)
        if (result.ok) {
          this.$router.push({ name: 'account/w9/form2' })
        }
      }
    },
  },

  created() {
    if(this.w9Progress) {
      this.name = this.w9Progress.business_name
      this.business_name = this.w9Progress.business_name
      this.street = this.w9Progress.street
      this.city = this.w9Progress.city
      this.state = this.w9Progress.state
      this.zipcode = this.w9Progress.zipcode
    }
  },
}
</script>

